var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRocket(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 256,
    height: 256,
    fill: "none",
    viewBox: "0 0 256 256",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_195_25)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 256,
    height: 256,
    fill: "#D33847",
    rx: 60
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_195_25)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M60.1667 154.5C60.4719 160.761 62.3217 166.466 65.7011 171.398L55.2169 181.48C54.1089 182.643 55.0123 183.605 56.3124 184.976L65.3922 194.488C66.6461 195.876 67.4932 196.739 68.6498 195.606L80.0232 184.703C82.7563 185.952 89.2812 188.297 98.9516 187.788L106.161 182.818C106.699 182.443 107.645 181.903 108.273 181.609L114.817 178.544L109.693 183.518C109.203 183.994 108.363 184.686 107.829 185.058L101.63 189.33L114.076 220.63C114.201 220.946 114.398 221.236 114.65 221.475C114.902 221.714 115.2 221.893 115.518 221.997C115.836 222.101 116.163 222.125 116.47 222.069C116.776 222.012 117.053 221.876 117.275 221.673L141.821 199.447C142.107 199.188 142.291 198.831 142.345 198.427L146.534 166.463C153.257 161.016 160.017 154.575 166.639 147.314C204.752 105.508 209.031 70.3982 208.193 53.1931C207.916 47.526 207.08 44.3388 207.048 44.2063C206.944 43.8195 206.733 43.4561 206.44 43.1623C206.148 42.8685 205.787 42.6575 205.404 42.5561C203.382 42.0178 155.2 30.0236 96.0217 86.7568C95.9485 86.8361 88.2738 94.4628 80.1445 105.412L48.623 111.314C48.2473 111.386 47.9188 111.576 47.6818 111.859L26.2902 137.217C26.097 137.447 25.971 137.731 25.9234 138.044C25.8758 138.356 25.9081 138.686 26.0175 139.006C26.1269 139.325 26.3099 139.623 26.5501 139.873C26.7903 140.123 27.0802 140.317 27.3937 140.438L58.3767 152.305L63.2274 146.834C63.6576 146.348 64.4315 145.619 64.9589 145.195L70.4566 140.787L66.7038 146.816C66.2728 147.495 65.7949 148.138 65.2732 148.742L60.1667 154.5ZM124.362 94.2278C133.968 85.0116 148.266 84.3831 156.296 92.832C164.331 101.281 163.054 115.596 153.445 124.816C143.839 134.032 129.545 134.656 121.511 126.211C113.476 117.762 114.757 103.444 124.362 94.2278V94.2278Z",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_195_25)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint0_linear_195_25)",
    fillOpacity: 0.1,
    fillRule: "evenodd",
    d: "M124.303 94.3344C133.909 85.114 148.207 84.4898 156.237 92.9387C164.272 101.388 162.995 115.702 153.385 124.918C143.78 134.139 129.486 134.763 121.452 126.314C113.417 117.865 114.698 103.551 124.303 94.3344V94.3344Z",
    clipRule: "evenodd"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_195_25",
    width: 217.034,
    height: 215.609,
    x: -0.087,
    y: 23.815,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -8.663
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.663
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    mode: "normal",
    result: "effect1_dropShadow_195_25"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_195_25",
    mode: "normal",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_195_25",
    width: 79.999,
    height: 79.927,
    x: 90.183,
    y: 69.663,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -8.663
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.663
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    mode: "normal",
    result: "effect1_dropShadow_195_25"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_195_25",
    mode: "normal",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_195_25",
    x1: 108.994,
    x2: 157.274,
    y1: 138.249,
    y2: 92.474,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_195_25"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 256,
    height: 256,
    fill: "#fff",
    rx: 60
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRocket);
export default __webpack_public_path__ + "static/media/Rocket.77a5ba3b25cdcebe4debb5ad26ea833e.svg";
export { ForwardRef as ReactComponent };